module.exports = "/dist/assets/images/bring.svg";